import type { ReactNode } from 'react'

interface ChipProps {
  children: ReactNode
  selected: boolean
  onClick: () => void
  disabled?: boolean
}

/**
 * 값을 고르는 조각.
 *
 * 고르지 않은 조각은 면 없이 ink-muted 테두리와 ink 라벨이고, 고른 조각은 accent 면에
 * accent-ink 테두리와 라벨이다. 고른 것을 면색으로만 알리면 고르지 않은 조각이 무엇인지
 * 형태로 말하지 못한다.
 */
export function Chip({ children, selected, onClick, disabled }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      disabled={disabled}
      className={`pressable flex min-h-11 shrink-0 items-center gap-1.5 rounded-full border px-4 text-sm disabled:opacity-60 ${
        selected ? 'bg-accent text-accent-ink border-accent-ink' : 'border-ink-muted text-ink'
      }`}
    >
      {children}
    </button>
  )
}
